import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";
import { WindowMU } from "app/types/WindowMU";

declare var window:WindowMU

export async function removerFormaPagamento() {
    const dadosOrcamentoAtualizados = await microuniversoApi.Orcamento.removerFormaPagamento(
        store.getState().orcamento.IdentificadorOrcamento
    )

    window.orcamentoController.model.atualizar({
        ...dadosOrcamentoAtualizados,
        CodigoFormaPagamento: undefined,
        CodigoTipoDocumento: undefined,
        ParcelasFormaPagamento: undefined
    }, true,true)
}